import React, { Component } from 'react';
import {connect} from 'react-redux';
import {Modal} from 'react-bootstrap';
import * as actionCreators from "../../action/index.js";
import Iframe from 'react-iframe'



class MaintenanceWindow extends Component {
  constructor(props) {
    super(props);
    
  }
  handleClick = ()=>{
    this.props.handleClose();
  }

  render() {
    let style;

  if (window.screen.availWidth < 500) {
    style = {'padding': '40px 20px'};
  }
    if(this.props.const_var.alertUsedFor=="ManageKlinkExpire")
    {
      return (
         <div>
            <Modal centered show={this.props.const_var.isShowAlert} dialogClassName="alert-modal react-modal" backdrop='static' keyboard={false} >            
              
              <Modal.Body  style={style}>
                <h5 className="modal-title mb-3">Alert</h5>
                  <div className="row">
                    <div className="col-12">
                      <p>{this.props.const_var.alertExpireMessage}</p>
                    </div>
                  </div>

                   <div className="alert-footer"> 
                  <a className="btn btn-secondary text-uppercase mw-100" href={this.props.const_var.crmSetting.page}>               
                <span className="text">Go back to Estimator</span>                 
              </a>
            </div>
            </Modal.Body>       
           
          </Modal>
        </div>
      )
    }else
    {
    	return <div className="maintenance-window">
          <Iframe src="https://crm.senseicrm.com/login" />
      </div>;
    }
  }
}


const mapStoreToProps = (state) => {
  return state.reducer
}

export default connect(
  mapStoreToProps,
  null
)
(MaintenanceWindow)



